@import "/src/variables/icon";
@import "/src/variables/tokens";

:where(.icon) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: $line-height-ratio-1;
}

.xs {
  font-size: $icon-size-xs;
}

.sm {
  font-size: $icon-size-sm;
}

.md {
  font-size: $icon-size-md;
}

.lg {
  font-size: $icon-size-lg;
}

.xl {
  font-size: $icon-size-xl;
}

.spinner {
  width: 1em;
  height: 1em;
  border: $border-width-2 solid transparent;
  border-color: color-mix(in srgb, currentColor 45%, transparent);
  border-top-color: currentColor;
  border-radius: $border-radius-round;
  animation: iconSpin 0.7s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
}

@keyframes iconSpin {
  to {
    transform: rotate(360deg);
  }
}
